import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { AutomationReplacementChipsComponent } from '../../../../../../../../common/components';
import { DynamicOptionsComponent } from '../../../../dynamic-options';
import { CombinedCampaignSelectorService } from '../../../../../../../../data-services/combined-campaign-selector.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, AutomationReplacementChipsComponent],
  selector: 'automata-campaign-selector',
  templateUrl: './campaign-selector.component.html',
})
export class CampaignSelectorComponent implements OnInit, DynamicOptionsComponent {
  private destroyRef = inject(DestroyRef);
  protected readonly cdr = inject(ChangeDetectorRef);
  protected readonly translateService = inject(TranslateService);
  protected readonly campaignSelectorService = inject(CombinedCampaignSelectorService);

  @Input() required = true;

  @Input() initialValue: any[] = [];
  @Output() loaded: EventEmitter<null> = new EventEmitter<null>();

  campaignControl = new FormControl<string>('', { nonNullable: true, validators: [Validators.required] });

  selectedValue$ = this.campaignControl.valueChanges;

  ngOnInit(): void {
    this.campaignControl.setValue(this.initialValue[0]);
  }

  finishedLoading(): void {
    this.loaded.emit();
  }

  getControlsToValidateOnSave(): FormControl[] {
    return [this.campaignControl];
  }

  isFormValid(): boolean {
    return !this.campaignControl.invalid;
  }

  // filter interface
  getSelectedValue(): string[] {
    return [this.campaignControl.value];
  }
}
